var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compo-form-item"},[_vm._m(0),_c('div',{staticClass:"compo-form-body"},[_c('PaymentSummaryData',{attrs:{"productItem":_vm.productItem}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compo-form-name"},[_c('label',{staticClass:"compo-form-title"},[_vm._v("결제정보")])])
}]

export { render, staticRenderFns }